import { isMetadataFinishedAtom } from "../app-state"
import {
	metadataAtom,
	allFileFormatsAtom,
	allPhotosAtom,
	displayedPhotosAtom,
	sortedPhotosAtom,
} from "../photo/photos-state"
import { store } from "../store"
import { projectAtom } from "./projects-state"
import { getFileExtension } from "@/utils/file"

export const getCurrentProjectMetadataAnalyticsInfo = () => {
	const project = store.get(projectAtom)
	if (!project) {
		return null
	}
	const isMetadataFinished = store.get(isMetadataFinishedAtom)

	const basicInfo = {
		projectId: project.id,
		totalCount: project.photoCount,
		styleId: project.styleId,
		isMetadataFinished: false,
	}

	if (!isMetadataFinished) {
		return basicInfo
	}

	return {
		...basicInfo,
		fileFormatInfo: store.get(allFileFormatsAtom),
		isMetadataFinished: true,
	}
}

export const getFirstFileMetadataAnalyticsInfo = () => {
	const displayedPhotos = store.get(displayedPhotosAtom)
	const sortedPhotos = store.get(sortedPhotosAtom)
	const allPhotos = store.get(allPhotosAtom)
	const firstPhoto = displayedPhotos[0] ?? sortedPhotos[0] ?? allPhotos[0]
	if (!firstPhoto) {
		return {
			firstFileFormat: null,
			firstFileDimension: null,
		}
	}

	const firstMetadata = store.get(metadataAtom)[firstPhoto.id]
	const fallbackFormat = getFileExtension(firstPhoto.fileName)?.toUpperCase() ?? null
	const rawFirstFileFormat = firstMetadata?.extension?.toUpperCase() ?? fallbackFormat
	const firstFileFormat = rawFirstFileFormat === "JPG" ? "JPEG" : rawFirstFileFormat
	const firstFileDimension =
		firstMetadata?.width && firstMetadata?.height
			? `${firstMetadata.width}x${firstMetadata.height}`
			: null

	return {
		firstFileFormat,
		firstFileDimension,
	}
}
